module.exports = __webpack_public_path__ + "img/gard_horizontal_1.e705ca8f.png";